import { createLazyFileRoute } from "@tanstack/react-router";

import { NewInstrumentPage } from "@/features/admin/routes/InstrumentNew";

export const Route = createLazyFileRoute("/_auth/admin/instruments/new")({
  component: NewInstrumentPage,
});
